"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
// Note: this component is only used for providing example markup to the styleguide.
// Do not import it directly into the application.
function PageError() {
    return ((0, jsx_runtime_1.jsxs)("section", { className: "page-error", children: [(0, jsx_runtime_1.jsx)("h1", { children: "Page Not Found" }), (0, jsx_runtime_1.jsx)("p", { children: "Sorry, looks like the page you're looking for was moved or doesn't exist." }), (0, jsx_runtime_1.jsx)("a", { href: "/", className: "button-primary-outline", children: "Back to Homepage" })] }));
}
exports.default = PageError;
